<template>
  <div class="el-drawer">
    <el-drawer
      class=".el-drawer__body"
      title="Récapitulatif du panier en cours"
      :visible.sync="shouldDisplayDrawer"
      :direction="direction"
      :before-close="handleClose">
      <CartPreviewDisplay :cartBySupplier="cartBySupplier" v-if="!isCartEmpty"/>
      <h3 v-if="isCartEmpty">Votre panier est vide</h3>
    </el-drawer>
  </div>
</template>

<script>
  import _ from 'lodash';
  import CartPreviewDisplay from './CartPreviewDisplay/CartPreviewDisplay.vue';

  export default {
    components: { CartPreviewDisplay },
    props: {
      displayDrawer: Boolean,
      cartBySupplier: {},
    },
    data() {
      return {
        direction: 'rtl',
        shouldDisplayDrawer: this.displayDrawer,
      };
    },
    computed: {
      isCartEmpty() {
        return _.isEmpty(this.cartBySupplier);
      },
    },
    methods: {
      handleClose() {
        this.shouldDisplayDrawer = false;
        this.$emit('closeCartPreview');
      },
    },
  };
</script>

<style lang="stylus">
  .el-drawer {
    background-color #edf1f8;
  }

  .el-drawer__body {
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
  }
</style>
